import type { ChannelStats } from '../../../lib/surveyResults';

// Phase 6B E3 — per-channel invite breakdown (§6.3). One row per channel the
// survey used; SMS renders em-dashes for open/click (no engagement signal).
// Visual parity with the broadcast results per-channel rows.

const COLS: { key: keyof ChannelStats; label: string }[] = [
  { key: 'sent', label: 'Sent' },
  { key: 'delivered', label: 'Delivered' },
  { key: 'opened', label: 'Opened' },
  { key: 'clicked', label: 'Clicked' },
  { key: 'bounced', label: 'Bounced' },
  { key: 'failed', label: 'Failed' },
  { key: 'unsubscribed', label: 'Unsubscribed' },
];

export function ChannelBreakdown({ email, sms }: { email?: ChannelStats; sms?: ChannelStats }) {
  if (!email && !sms) return null;
  return (
    <section className="mb-8">
      <h2 className="mb-2 text-sm font-semibold text-slate-800">Invite delivery</h2>
      <div className="overflow-hidden rounded-lg border border-slate-200">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-left text-xs uppercase tracking-wide text-slate-500">
            <tr>
              <th className="px-4 py-2 font-medium">Channel</th>
              {COLS.map((c) => (
                <th key={c.key} className="px-3 py-2 text-right font-medium">{c.label}</th>
              ))}
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {email && <Row label="Email" stats={email} />}
            {sms && <Row label="SMS" stats={sms} />}
          </tbody>
        </table>
      </div>
    </section>
  );
}

function Row({ label, stats }: { label: string; stats: ChannelStats }) {
  return (
    <tr>
      <td className="px-4 py-2 font-medium text-slate-800">{label}</td>
      {COLS.map((c) => {
        const v = stats[c.key];
        return (
          <td key={c.key} className="px-3 py-2 text-right text-slate-600">
            {v === null ? '—' : v}
          </td>
        );
      })}
    </tr>
  );
}
